type Props = {
  height: string;
  stroke: string;
  strokeWidth: string;
  width: string;
};

const ChevronRightStretched = ({
  width = '12',
  height = '32',
  stroke = '#F2F2F2',
  strokeWidth = '2'
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 32"
      fill="none"
    >
      <path
        d="M5 1L10.7029 15.2572C10.8936 15.734 10.8936 16.266 10.7029 16.7428L5 31"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
};

export default ChevronRightStretched;
